import axios from "axios";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../url/api";

interface Payment {
  id: number;
  payment_id: string;
  amount: number;
  status: string;
  created_at: string;
}

interface User {
  id: number;
  name: string;
  email: string;
  created_at: string;
  payment: Payment[];
}

const BillingPaymentPage: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userId = localStorage.getItem("userId") || "1";
        const response = await axios.get<User>(
          `${API_URL}user/${userId}/payment-list/`
        );
        setUser(response.data);
        setLoading(false);
      } catch (error) {
        setError("Failed to fetch user data");
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!user) {
    return null;
  }

  return (
    <div className="container mx-auto p-4 md:p-8">
      <h1 className="text-3xl font-bold mb-6">Billing Payment</h1>
      <div className="bg-white shadow-md rounded-lg overflow-x-auto mt-6 ml-0 md:ml-4 max-w-4xl">
        <table className="min-w-full divide-y divide-gray-200 overflow-hidden">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-nowrap">
                ID
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-nowrap">
                Amount
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-nowrap">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-nowrap">
                Payment Details
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            
              {user.payment.map((payment) => (
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {payment.payment_id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    ${payment.amount.toFixed(2)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {payment.status}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {new Date(payment.created_at).toLocaleString()}
                  </td>
                </tr>
              ))}

              {/* <td className="px-6 py-4 whitespace-nowrap">{user.id}</td>
            <td className="px-6 py-4 whitespace-nowrap">${payment.amount.toFixed(2)}</td>
            <td className="px-6 py-4 whitespace-nowrap">{user.email}</td>
            <td className="px-6 py-4 whitespace-nowrap">{new Date(user.created_at).toLocaleString()}</td>
            <td className="px-6 py-4 whitespace-nowrap">
              {user.payment.map((payment) => (
                <div key={payment.id} className="mb-2">
                  <p className="text-sm font-medium text-gray-900">Payment ID: {payment.payment_id}</p>
                  <p className="text-sm text-gray-500">Amount: ${payment.amount.toFixed(2)}</p>
                  <p className="text-sm text-gray-500">Status: {payment.status}</p>
                  <p className="text-sm text-gray-500">Created At: {new Date(payment.created_at).toLocaleString()}</p>
                </div>
              ))}
            </td> */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BillingPaymentPage;
